import { Box, Typography } from "@mui/material";
import { ArrowRight2 } from "iconsax-react";
import { Link } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

import { PageHeader } from "@/components/Molecules";
import { CommissionLockedState, QuickOrderPanel } from "@/components/Organisms";
import { PageTemplate } from "@/components/Templates/Page";
import type { CreateOrderTemplateProps } from "./CreateOrder.template.types";
import * as styles from "./CreateOrder.template.styles";

export type { CreateOrderTemplateProps } from "./CreateOrder.template.types";

export function CreateOrderTemplate({
  searchQuery,
  onSearchChange,
  filteredProducts,
  cartItems,
  totalPrice,
  orderLink,
  orderError,
  isProductsLoading,
  isCreatingOrder,
  categories,
  activeCategoryId,
  onCategoryChange,
  onAddProduct,
  onRemoveProduct,
  onQuantityChange,
  onCreateOrderLink,
  onEditCart,
  onReset,
  isBlocked,
  canPayDebt,
}: CreateOrderTemplateProps) {
  const { t } = useTranslation(["orders", "common"]);

  return (
    <PageTemplate>
      <Box sx={styles.headerBlock}>
        <Link to="/orders" style={{ textDecoration: "none" }}>
          <Typography component="span" sx={styles.backLink}>
            <ArrowRight2 size={16} variant="Linear" />
            {t("create.backToOrders")}
          </Typography>
        </Link>
        <PageHeader title={t("orders:create.title")} subtitle={t("orders:create.subtitle")} />
      </Box>

      {isBlocked ? (
        <CommissionLockedState canPayDebt={canPayDebt} />
      ) : (
        <QuickOrderPanel
          searchQuery={searchQuery}
          onSearchChange={onSearchChange}
          filteredProducts={filteredProducts}
          cartItems={cartItems}
          totalPrice={totalPrice}
          orderLink={orderLink}
          orderError={orderError}
          isProductsLoading={isProductsLoading}
          isCreatingOrder={isCreatingOrder}
          categories={categories}
          activeCategoryId={activeCategoryId}
          onCategoryChange={onCategoryChange}
          onAddProduct={onAddProduct}
          onRemoveProduct={onRemoveProduct}
          onQuantityChange={onQuantityChange}
          onCreateOrderLink={onCreateOrderLink}
          onEditCart={onEditCart}
          onReset={onReset}
        />
      )}
    </PageTemplate>
  );
}
